export default __webpack_public_path__ + "static/media/001-popcorn.46ec6dfd.png";